import React, { useEffect } from "react";
import { useGestionAlmacen } from "../hooks/useGestionAlmacen";
import LoadMask from "Utils/LoadMask/LoadMask";
import { Recepciones } from "./Recepciones";
import { AnalisisDRC } from "./AnalisisDRC/AnalisisDRC";
import { DatosAlmacenInventario } from "../../../components/Almacenes/DatosAlmacenInventario";
import { ResumenRecepcionesDRC } from "../../../components/Almacenes/ResumenRecepcionesDRC";

export const AlmacenForm = (props) => {
    const {
        almacenInventarioId,
        regresar,
        setAlmacenInventarioNombre,
        categoriaAcopio,
    } = props;

    const {
        almacenDetalle,
        movimientos,
        setMovimientos,
        GuardarGestionAlmacen,
        cargando,
    } = useGestionAlmacen(almacenInventarioId, regresar);

    const estaCerrado = almacenDetalle.inventario_almacen
        ? almacenDetalle.inventario_almacen.esta_cerrado
        : false;

    const estadoAlmacenInventario =
        almacenDetalle && almacenDetalle.inventario_almacen
            ? almacenDetalle.inventario_almacen.estado
            : null;

    useEffect(() => {
        if (
            almacenDetalle &&
            almacenDetalle.inventario_almacen &&
            almacenDetalle.inventario_almacen.nombre_almacen
        ) {
            setAlmacenInventarioNombre(
                almacenDetalle.inventario_almacen.nombre_almacen,
            );
        }
    }, [almacenDetalle]);

    return (
        <LoadMask loading={cargando} blur>
            <DatosAlmacenInventario
                datosAlmacen={
                    almacenDetalle && almacenDetalle.inventario_almacen
                }
            />
            <AnalisisDRC
                almacenInventarioId={almacenInventarioId}
                estaCerrado={estaCerrado}
            />
            <Recepciones
                almacenInventarioId={almacenInventarioId}
                estadoAlmacenInventario={estadoAlmacenInventario}
                movimientosAlmacen={movimientos}
                setMovimientosAlmacen={setMovimientos}
                estaCerrado={estaCerrado}
                categoriaAcopio={categoriaAcopio}
            />
            <ResumenRecepcionesDRC
                datosAlmacen={
                    almacenDetalle && almacenDetalle.inventario_almacen
                }
                movimientos={movimientos}
            />
            <div
                className="d-flex justify-content-center mt-3"
                style={{ gap: "1rem" }}
            >
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
                {!estaCerrado && (
                    <button
                        className="btn btn-primary"
                        onClick={GuardarGestionAlmacen}
                    >
                        Guardar
                    </button>
                )}
            </div>
        </LoadMask>
    );
};
